import Poll from '../components/Poll.vue'
import PageNotFound from '../components/PageNotFound.vue'
import Error from '../components/Error.vue'
import BlockedCookies from "@/components/BlockedCookies.vue"

const routes = [
  {
    path: '/:id',
    component: Poll
  },
  {
    path: '/pagenotfound',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
    props: true
  },
  {
    path: '/blocked-cookies',
    name: 'BlockedCookies',
    component: BlockedCookies,
    props: true
  }
];

export default routes
